var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / multiply"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M5.28814 4.22748C4.99525 3.93459 4.52038 3.93459 4.22748 4.22748C3.93459 4.52038 3.93459 4.99525 4.22748 5.28814L7.93979 9.00045L4.22748 12.7128C3.93459 13.0057 3.93459 13.4805 4.22748 13.7734C4.52038 14.0663 4.99525 14.0663 5.28814 13.7734L9.00045 10.0611L12.7128 13.7734C13.0057 14.0663 13.4805 14.0663 13.7734 13.7734C14.0663 13.4805 14.0663 13.0057 13.7734 12.7128L10.0611 9.00045L13.7734 5.28814C14.0663 4.99525 14.0663 4.52038 13.7734 4.22748C13.4805 3.93459 13.0057 3.93459 12.7128 4.22748L9.00045 7.93979L5.28814 4.22748Z",
    fill: "#A73205"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSvg);
export default __webpack_public_path__ + "static/media/CloseSvg.5c9adba1f300f0818df3e19a6e05331b.svg";
export { ForwardRef as ReactComponent };